import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  requestExigenciasRelatorio,
  requestMotivosRelatorio,
  trataMensagensErro,
} from '../../utils/requests';
import { DataGridCustom, Grid, Input, Table, Button } from '../index';

class SelecaoMultipla extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

  getInitialState = () => ({
    // item: null,
    lista: [],
    desabilitarBotaoInclusao: true,
  })

  componentDidMount() {
    // if (this.props.configuracao && this.props.configuracao.origem !== 'filtroSimulacaoCompensacao') {
    //   this.buscaDadosDeDominio();
    // }
    if (!this.props.configuracao || (this.props.configuracao && this.props.configuracao.origem !== 'filtroSimulacaoCompensacao')) {
      this.buscaDadosDeDominio();
    }
  }

  deleteItem = (row) => {
    const { lista } = { ...this.props };
    lista.splice(row, 1);
    this.alteraLista(lista);
    this.verificarHabilitacaoBotaoIncluir();
  }

  buscaDadosDeDominio = () => {
    if (this.props.exigencias.length === 0) {
      requestExigenciasRelatorio(this.tratarErro);
    }
    if ((this.props.motivosIndeferimento.length === 0) ||
      (this.props.motivosSuspensao.length === 0) ||
      (this.props.motivosCessacao.length === 0)) {
      requestMotivosRelatorio(this.tratarErro);
    }
    return null;
  }

  createActionColumn = indice => (
    <React.Fragment>
      <Button
        className="dtp-inverse"
        hint="Excluir do filtro"
        icon="ico-doc-minus"
        mini
        onClick={() => this.deleteItem(indice)}
      />
    </React.Fragment>
  );

  colunasDefault = [{
    id: 'label',
    label: 'Estado',
  },
  {
    id: 'codigo',
    label: 'Código',
  },
  {
    id: 'acoes',
    label: 'Excluir',
    dataFormat: this.createActionColumn,
  }];

  colunasMultiplosEstados = [{
    id: 'label',
    label: 'Opção',
  },
  {
    id: 'value',
    label: 'Código',
  },
  {
    id: 'acoes',
    label: 'Excluir',
    dataFormat: this.createActionColumn,
  }];

  options = {
    hideSizePerPage: true,
    noDataText: 'Nenhum item foi adicionado à lista',
    sizePerPage: 5,
  };

  fetchInfo = {};

  handleChange = (changeObj, name) => {
    this.props.handleChange(changeObj, name, this.addItem);
  }

  handleChangeEstadoMultiplo = (changeObj, name) => {
    this.props.handleChange(changeObj, name, this.verificarHabilitacaoBotaoIncluir);
  }

  handleChangeMultiplo = (changeObj, name) => {
    this.props.handleChange(changeObj, name);
    this.setState({ desabilitarBotaoInclusao: false });
  }

  alteraLista = (lista) => {
    this.props.handleChange({ value: lista, isValid: lista.length > 0 });
  }

  verificarHabilitacaoBotaoIncluir = () => {
    if (this.props.valorComboSelecaoMultipla !== null) {
      this.setState({ desabilitarBotaoInclusao: false });
    } else {
      this.setState({ desabilitarBotaoInclusao: true });
    }
  }

  verificarItemInseridoNaLista = () => {
    let retorno = false;
    const index = this.props.lista.findIndex(item => (item.value === this.props.valorComboSelecaoMultipla));
    if (index !== -1) {
      retorno = true;
    }
    return retorno;
  }

  retornarListaPorEstado = (estado) => {
    let listaPorEstado;
    switch (estado) {
      case '2':
        listaPorEstado = this.props.exigencias;
        break;
      case '9':
        listaPorEstado = this.props.motivosIndeferimento;
        break;
      case '10':
        listaPorEstado = this.props.motivosSuspensao;
        break;
      case '12':
        listaPorEstado = this.props.motivosCessacao;
        break;
      default:
        listaPorEstado = [];
        break;
    }
    return listaPorEstado;
  }


  addItemMultiplo = () => {
    if (this.props.valorComboSelecaoMultipla) {
      const { lista } = { ...this.props };
      const existeNaLista = this.verificarItemInseridoNaLista();
      let labelItem = '';
      if (existeNaLista) {
        trataMensagensErro(['O item já existe na lista']);
      } else {
        if (this.props.configuracao.origem === 'filtroSimulacaoCompensacao') {
          const index = this.props.estadosSimulacaoCompensacao.findIndex(i => (i.value === this.props.valorComboSelecaoMultipla));
          if (index !== -1) {
            labelItem = this.props.estadosSimulacaoCompensacao[index].label;
          }
        } else {
          const listaPorEstado = this.retornarListaPorEstado(this.props.estado);
          const index = listaPorEstado.findIndex(i => (i.value === this.props.valorComboSelecaoMultipla));
          if (index !== -1) {
            labelItem = listaPorEstado[index].label;
          }
        }
        const item = { label: labelItem, value: this.props.valorComboSelecaoMultipla, codigo: this.props.valorComboSelecaoMultipla };
        lista.push(item);
        this.alteraLista(lista);
        this.setState(() => this.verificarHabilitacaoBotaoIncluir());
      }
    }
  }

  addItem = () => {
    if (this.props.valorComboSelecaoMultipla) {
      const { lista } = { ...this.props };
      let item = null;
      let titulo = '';
      if (this.props.configuracao.origem === 'filtroSimulacaoCompensacao') {
        const index = this.props.estadosSimulacaoCompensacao.findIndex(i => (i.value === Number(this.props.valorComboSelecaoMultipla)));
        if (index !== -1) {
          titulo = this.props.estadosSimulacaoCompensacao[index].label;
        }
      } else {
        const listaPorEstado = this.retornarListaPorEstado(this.props.estado);
        const index = listaPorEstado.findIndex(i => (i.value === Number(this.props.valorComboSelecaoMultipla)));
        if (index !== -1) {
          titulo = listaPorEstado[index].label;
        }
      }
      item = { label: titulo, value: this.props.valorComboSelecaoMultipla };
      lista.push(item);
      this.alteraLista(lista);
    } else if (this.props.valorComboSelecaoMultipla === '') {
      let { lista } = { ...this.props };
      if (lista.length > 0) {
        lista = [];
        this.alteraLista(lista);
      }
    }
  }

  verificarSeEstadoPossuiSelecaoMultipla = () => {
    let ehSelecaoMultipla = false;
    const estadoSelecionado = this.props.estado;
    if (estadoSelecionado) {
      ehSelecaoMultipla = this.props.listaEstadosComSelecaoMultipla.includes(Number(estadoSelecionado));
    } else if (this.props.configuracao.origem === 'filtroSimulacaoCompensacao') {
      ehSelecaoMultipla = true;
    }
    return ehSelecaoMultipla;
  };

  recuperarListaPorOrigem = () => {
    let retorno = [];
    if (this.props.configuracao.origem === 'filtroSimulacaoCompensacao') {
      retorno = this.props.estadosSimulacaoCompensacao;
    } else {
      retorno = this.retornarListaPorEstado(this.props.estado);
    }
    return retorno;
  }

  render() {
    const listaIndexada = this.props.lista.map((item, i) => {
      const itemIndexado = item;
      itemIndexado.acoes = i;
      return itemIndexado;
    });
    return (
      <React.Fragment>
        {this.props.estado !== null ?
          <DataGridCustom title={this.props.configuracao.titulo} retirarLinhaSeparadora={this.props.configuracao.retirarLinhaSeparadora}>
            <div className="row">
              <Grid cols="6 6 6 6">
                {(this.props.configuracao.exibirComboBox && this.props.configuracao.origem === 'filtroSimulacaoCompensacao') ?
                  <Input
                    label={this.props.configuracao.labelCombobox}
                    onChange={e => this.handleChangeMultiplo(e, 'valorComboSelecaoMultipla')}
                    placeholder="Todos"
                    value={this.props.valorComboSelecaoMultipla}
                    itemList={this.recuperarListaPorOrigem()}
                    custom
                    number
                    integer
                  />
                :
                  <Input
                    label={this.props.configuracao.labelCombobox}
                    onChange={this.verificarSeEstadoPossuiSelecaoMultipla() ?
                      e => this.handleChangeEstadoMultiplo(e, 'valorComboSelecaoMultipla') :
                      e => this.handleChange(e, 'valorComboSelecaoMultipla')}
                    placeholder="Todos"
                    value={this.props.valorComboSelecaoMultipla}
                    itemList={this.recuperarListaPorOrigem()}
                    custom
                    number
                    integer
                  />
                }
              </Grid>
              <Grid cols="6 6 6 6">
                {this.props.configuracao.exibirBotaoIncluir ?
                  <Button
                    hint={`incluir ${this.props.hint} ao filtro`}
                    icon="ico-plus"
                    mini
                    disabled={this.state.desabilitarBotaoInclusao}
                    onClick={this.verificarSeEstadoPossuiSelecaoMultipla() ? () => this.addItemMultiplo() : () => this.addItem()}
                  />
                : '' }
              </Grid>
            </div>
            <div className="row">
              <Grid cols="12 12 12 12">
                {this.props.configuracao.exibirTabelaItens ?
                  <Table
                    bordered
                    data={listaIndexada}
                    options={this.options}
                    listaTableHeader={this.props.configuracao.origem === 'filtroSimulacaoCompensacao' ? this.colunasDefault : this.colunasMultiplosEstados}
                    pagination
                    fetchInfo={this.fetchInfo}
                  />
                : '' }
              </Grid>
            </div>
            <div className="row">
              <Grid cols="12 12 12 12">
                <p />
              </Grid>
            </div>
          </DataGridCustom>
        : '' }
      </React.Fragment>
    );
  }
}

SelecaoMultipla.propTypes = {
  handleChange: PropTypes.func.isRequired,
  configuracao: PropTypes.shape({
    origem: PropTypes.string,
    labelCombobox: PropTypes.string,
    titulo: PropTypes.string,
    exibirBotaoIncluir: PropTypes.bool,
    exibirTabelaItens: PropTypes.bool,
    retirarLinhaSeparadora: PropTypes.bool,
    exibirComboBox: PropTypes.bool,
  }).isRequired,
  estado: PropTypes.number.isRequired,
  hint: PropTypes.string.isRequired,
  valorComboSelecaoMultipla: PropTypes.string.isRequired,
  listaEstadosComSelecaoMultipla: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
  })).isRequired,
  lista: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })).isRequired,
  exigencias: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  motivosIndeferimento: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  motivosSuspensao: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  motivosCessacao: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  estadosSimulacaoCompensacao: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

SelecaoMultipla.defaultProps = {
  exigencias: [],
  motivosIndeferimento: [],
  motivosSuspensao: [],
  motivosCessacao: [],
  estadosSimulacaoCompensacao: [],
};

// eslint-disable-next-line
const mapStateToProps = (state) => ({
  exigencias: state.base.exigenciasRelatorio,
  motivosIndeferimento: state.base.motivosIndeferimentoRelatorio,
  motivosSuspensao: state.base.motivosSuspensaoRelatorio,
  motivosCessacao: state.base.motivosCessacaoRelatorio,
  estadosSimulacaoCompensacao: state.base.estadosSimulacaoCompensacao,
});

export default connect(mapStateToProps)(SelecaoMultipla);



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/SelecaoMultipla.jsx